import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=bde8fbfa&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=bde8fbfa&scoped=true&lang=css&"
import style1 from "./Main.vue?vue&type=style&index=1&id=bde8fbfa&scoped=true&lang=scss&"
import style2 from "./Main.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde8fbfa",
  null
  
)

export default component.exports